

























/* Created- 28 - Mar - 2019 */
import { Component, Vue, Prop, Watch } from "vue-property-decorator";

import ParticaError from "@/Ui-Components/Common/Error/ParticaError.vue";
import ParticaWebsiteForm from "@/Ui-Components/Domain/ParticaWebsiteForm.vue";
import { DomainService, IDomainService } from "../../BusinessServices/domain";
import ParticaBaseView from "../Base/ParticaBaseView.vue";
import ParticaRowContainer from "@/Ui-Components/Common/Container/ParticaRowContainer.vue";
import ParticaColumnContainer from "@/Ui-Components/Common/Container/ParticaColumnContainer.vue";
import ParticaCard from "@/Ui-Components/Common/Container/ParticaCard.vue";
import { getActionName, ParticaEvent, eParticaAction } from "../../Models/ParticaEvent";
import { ButtonConfig, ButtonType, ButtonStatus } from "../../Models/Buttons";
import ParticaWebsiteBase from "../Base/ParticaWebsiteBase.vue";
import ParticaView from "@/Ui-Components/Common/ParticaView.vue";
import ButtonList from "@/Ui-Components/Common/Buttons/ButtonList.vue";
import ParticaDialogCard from "@/Ui-Components/Common/Container/ParticaDialogCard.vue";
import { ICustomerUrlModel, CustomerUrlModel, CustomerUrlModelSecure } from "../../Generated/ParticaAPI";

@Component(
	{
		name: "ParticaWebsite",
		components: {
			ParticaWebsiteForm,
			ParticaRowContainer,
			ParticaColumnContainer,
			ParticaCard,
			ParticaView,
			ButtonList,
			ParticaDialogCard,
		}
	})
export default class ParticaWebsite extends ParticaWebsiteBase {
	private data: ICustomerUrlModel | null = null;
	// create or inject services
	private domainService: IDomainService;
	@Prop() private id: number;
	private showWizard: boolean = false;
	private showViewerButtons: boolean = false;

	private buttons: ButtonConfig[] = [
		{ label: "Domain Security", action: eParticaAction.WEBSITE_SECURITY, type: ButtonType.OK } as ButtonConfig,
	];

	private async eventHandler(event: ParticaEvent) {
		try {
			this.LoadingStart();
			switch (event.action) {
				case eParticaAction.WEBSITE_SECURITY: {
					this.navigate("websitesecurity", { id: this.id.toString() });
					break;
				}
				case eParticaAction.WEBSITE_LOGIN: {
					let token: string = "";
					if (this.data !== null) {
						if (this.data.secure !== CustomerUrlModelSecure.Free) {
							token += await this.domainService.getAccessToken(this.id);
						}
						window.open(this.data.url + "/go?externalauthtoken=" + token);
					}
					break;
				}
				default:
					{
						this.baseEventHandler(event);
					}
			}
		} catch (error) {
			this.ShowErrorDialog(error, `Unhandled event. ${getActionName(event.action)}`);
		} finally {
			this.LoadingEnd();
		}
	}


	@Watch("$route")
	private async change(to: any, from: any) {
		await this.init();
	}
	private async mounted() {
		this.metadata.name = "Home";
		this.domainService = this.particaServices.getDomainService();
		if (this.$store.state.config.admin !== true) {
			this.buttons.pop();
		} else {
			const login = { label: "View Website", action: eParticaAction.WEBSITE_LOGIN, type: ButtonType.OK } as ButtonConfig;
			this.buttons.push(login);
		}
		await this.init();
	}

	private async init() {
		try {
			this.LoadingStart();
			this.data = null;
			await this.getWebsiteNav(this.id);
			this.breadcrumbs.pop();
			this.data = await this.domainService.getWebsite(this.id);
		} catch (error) {
			this.ShowErrorDialog(error, "error initializing component.");
		} finally {
			this.LoadingEnd();
		}
	}
}
